import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import InputMask from "react-input-mask";
import DatePicker from "react-datepicker/dist/react-datepicker";
import { getMonth, getYear } from "date-fns";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/core/Autocomplete";
import * as moment from "moment";
import UserDataModel from "./userDataModel";
import { Checkbox } from "primereact/checkbox";
import {
  _years,
  _months,
  _genders,
  _races,
  _ethnicity,
  _yes_no_unknown,
  _billingTypes,
  _insRelations,
  _ins,
} from "../../../GlobalData/date";

function UserData(props) {
  const years = _years;
  const months = _months;
  const genders = _genders;
  const [selectedGender, setSelectedGender] = useState({
    id: 0,
    title: "Select Gender",
  });
  const pregnants = _yes_no_unknown;
  const [selectedPregnant, setSelectedPregnant] = useState({
    id: 0,
    title: "No",
  });
  const races = _races;
  const [selectedRace, setSelectedRace] = useState({
    id: 10,
    title: "Refused",
  });
  const ethnicity = _ethnicity;
  const [selectedEthnicity, setSelectedEthnicity] = useState({
    id: 4,
    title: "Refused",
  });
  const isFirstTest = _yes_no_unknown;
  const [selectedIsFirstTest, setSelectedIsFirstTest] = useState({
    id: 0,
    title: "No",
  });
  const isInGroup = _yes_no_unknown;
  const [selectedIsInGroup, setSelectedIsInGroup] = useState({
    id: 0,
    title: "No",
  });
  const billingTypes = _billingTypes;
  const [selectedBilling, setSelectedBilling] = useState({
    id: 0,
    title: "Insurance",
  });
  const insRel = _insRelations;
  const [selectedRel, setSelectedRel] = useState({
    id: 0,
    title: "Self",
  });
  const insNames = _ins;
  const [selectedIns, setSelectedIns] = useState({
    id: 0,
    title: "Select Insurance",
  });
  const constrain = UserDataModel.constrain();
  const [data, setData] = useState(UserDataModel.initialize());
  const [noIns, setNoIns] = useState(false);
  useEffect(() => {
    if (props.email !== undefined || props.email !== "")
      setData({ ...data, email: props.email });
    if (props.patientInfo !== undefined && props.patientInfo.id !== undefined) {
      setSelectedGender(genders.find((o) => o.id === props.patientInfo.gender));
      setSelectedPregnant(
        pregnants.find((o) => o.id === props.patientInfo.pregnantStatus)
      );
      setSelectedRace(
        races.find((o) => o.id === Number(props.patientInfo.race))
      );
      setSelectedEthnicity(
        ethnicity.find((o) => o.id === Number(props.patientInfo.ethnicity))
      );
      setSelectedIsFirstTest(
        isFirstTest.find((o) => o.id === props.patientInfo.isFirstTest)
      );
      setSelectedIsInGroup(
        isInGroup.find((o) => o.id === props.patientInfo.isInGroup)
      );
      setSelectedBilling(
        billingTypes.find((o) => o.id === Number(props.patientInfo.billingType))
      );
      setSelectedRel(
        insRel.find((o) => o.id === Number(props.patientInfo.insRel))
      );
      let newValues = {
        firstName: props.patientInfo.firstName,
        lastName: props.patientInfo.lastName,
        dob: new Date(props.patientInfo.dob),
        gender: genders.find((o) => o.id === props.patientInfo.gender),
        pregnantStatus: pregnants.find(
          (o) => o.id === props.patientInfo.pregnantStatus
        ),
        race: races.find((o) => o.id === props.patientInfo.race),
        ethnicity: ethnicity.find((o) => o.id === props.patientInfo.ethnicity),
        isFirstTest: isFirstTest.find(
          (o) => o.id === props.patientInfo.isFirstTest
        ),
        isInGroup: isInGroup.find((o) => o.id === props.patientInfo.isInGroup),
        addressLine1: props.patientInfo.addressLine1,
        addressLine2: props.patientInfo.addressLine2,
        city: props.patientInfo.city,
        state: props.patientInfo.state,
        zip: props.patientInfo.zip,
        phone: props.patientInfo.phone,
        email: props.patientInfo.email,
        billingType: billingTypes.find(
          (o) => o.id === props.patientInfo.billingType
        ),
        clientCode: props.patientInfo.clientCode,
        insName: props.patientInfo.insName,
        insID: props.patientInfo.insID,
        insGroup: props.patientInfo.insGroup,
        insAddress: props.patientInfo.insAddress,
        insCity: props.patientInfo.insCity,
        insState: props.patientInfo.insState,
        insZip: props.patientInfo.insZip,
        insPhone: props.patientInfo.insPhone,
        insSubName: props.patientInfo.insSubName,
        insSubDOB:
          props.patientInfo.insSubDOB === ""
            ? new Date()
            : new Date(Date.parse(props.patientInfo.insSubDOB)),
        insRel: insRel.find((o) => o.id === props.patientInfo.insRel),
      };
      setData(newValues);
    }
    // history.push("/");
  }, [props.patientInfo]);
  useEffect(() => {
    checkRelationValidity(data.insRel);
  }, [data.insRel]);
  const onDataChanged = (name, newValue) => {
    setData({ ...data, [name]: newValue });
    props.onDataChanged({ ...data, [name]: newValue });
  };
  const checkDateValidity = (e, name) => {
    if (e.target.value === "") {
      setError(name, {
        type: "manual",
        message: "Date is required.",
      });
    } else {
      var date = moment(e.target.value, "MM/DD/YYYY");
      if (date.isValid()) {
        clearErrors(name);
      } else {
        clearErrors(name);
        setError(name, {
          type: "manual",
          message: "Invalid Date",
        });
      }
    }
  };
  const checkPhoneValidity = (e, name) => {
    const re =
      /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    if (re.test(e.target.value)) {
      clearErrors(name);
    } else {
      setError(name, {
        type: "manual",
        message: "Invalid " + name + " number.",
      });
    }
  };
  const checkEmailValidity = (e, name) => {
    const re =
      /^[a-zA-Z0-9][-a-z-A-Z0-9._]+@([-a-z-A-Z0-9]+[.])+[a-zA-Z]{2,5}$/;
    if (re.test(e.target.value)) {
      clearErrors(name);
    } else {
      setError(name, {
        type: "manual",
        message: "Invalid " + name + " address.",
      });
    }
  };
  const checkRelationValidity = (type) => {
    if (type === 1 || type === 2) {
      clearErrors("insSubDOB");
      clearErrors("insSubName");
    }
  };
  const { control } = useForm();
  const { errors, register, setError, clearErrors, isValid } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  });
  return (
    <>
      <div className="mx-auto px-2">
        <div
          style={{ marginTop: "10px" }}
          className=" col-md-12 col-sx-12 col-lg-12 col-sm-12"
        >
          <div className="card">
            <div className="card-header cardHeaderColor">
              <div className="card-title">Covid-19 Preliminary Information</div>
              <div className="custom-card-title "></div>
            </div>
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      First Name: <span className="is-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={data.firstName}
                      maxLength={constrain.firstName}
                      className={`upper-case  form-control ${
                        errors.firstName ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "Name is required",
                      })}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="firstName"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Last Name: <span className="is-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={data.lastName}
                      maxLength={constrain.lastName}
                      className={`upper-case  form-control ${
                        errors.lastName ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "LastName is required",
                      })}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="lastName"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      D.O.B:<span className="is-required">*</span>
                    </label>
                    <div className={`${errors.dob ? "is-invalid-date" : ""}`}>
                      <DatePicker
                        maxDate={new Date()}
                        renderCustomHeader={({
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled,
                        }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={decreaseMonth}
                              disabled={prevMonthButtonDisabled}
                            >
                              {"<"}
                            </button>
                            <select
                              value={getYear(date)}
                              onChange={({ target: { value } }) =>
                                changeYear(value)
                              }
                            >
                              {years.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <select
                              value={months[getMonth(date)]}
                              onChange={({ target: { value } }) =>
                                changeMonth(months.indexOf(value))
                              }
                            >
                              {months.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <button
                              onClick={increaseMonth}
                              disabled={nextMonthButtonDisabled}
                            >
                              {">"}
                            </button>
                          </div>
                        )}
                        name="dob"
                        selected={data.dob}
                        onChange={(e) => onDataChanged("dob", e)}
                        onBlur={(e) => checkDateValidity(e, "dob")}
                        className="form-control"
                      />
                    </div>
                    <div className="error-message">
                      {errors.dob && errors.dob.message}
                    </div>
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Gender: <span className="is-required">*</span>
                    </label>
                    <Controller
                      render={() => (
                        <Autocomplete
                          disableClearable
                          value={selectedGender}
                          size="small"
                          id="gender"
                          options={genders}
                          getOptionSelected={(option, value) =>
                            option.title === value.title
                          }
                          getOptionLabel={(option) => option.title}
                          onChange={(e, newValue) => {
                            onDataChanged("gender", newValue.id);
                            setSelectedGender(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        />
                      )}
                      defaultValue={genders[0]}
                      name="gender"
                      control={control}
                    />

                    <ErrorMessage
                      className="invalid-feedback"
                      name="gender"
                      as="div"
                      errors={errors}
                    />
                    {errors.gender && "Select Gender"}
                  </div>
                  {selectedGender.id === 2 && (
                    <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                      <label>
                        Currently Pregnant:{" "}
                        <span className="is-required">*</span>
                      </label>
                      <Controller
                        render={() => (
                          <Autocomplete
                            disableClearable
                            value={selectedPregnant}
                            size="small"
                            id="pregnantStatus"
                            options={pregnants}
                            getOptionSelected={(option, value) =>
                              option.title === value.title
                            }
                            getOptionLabel={(option) => option.title}
                            onChange={(e, newValue) => {
                              onDataChanged("pregnantStatus", newValue.id);
                              setSelectedPregnant(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} variant="outlined" />
                            )}
                          />
                        )}
                        defaultValue={pregnants[0]}
                        name="pregnantStatus"
                        control={control}
                      />
                    </div>
                  )}

                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>Race:</label>
                    <Controller
                      render={() => (
                        <Autocomplete
                          disableClearable
                          value={selectedRace}
                          size="small"
                          id="race"
                          options={races}
                          getOptionSelected={(option, value) =>
                            option.title === value.title
                          }
                          getOptionLabel={(option) => option.title}
                          onChange={(e, newValue) => {
                            onDataChanged("race", newValue.id);
                            setSelectedRace(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        />
                      )}
                      defaultValue={races[0]}
                      name="race"
                      control={control}
                    />

                    <ErrorMessage
                      className="invalid-feedback"
                      name="race"
                      as="div"
                      errors={errors}
                    />
                    {errors.race && "Select Race"}
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>Ethnicity:</label>
                    <Controller
                      render={() => (
                        <Autocomplete
                          disableClearable
                          value={selectedEthnicity}
                          size="small"
                          id="ethnicity"
                          options={ethnicity}
                          getOptionSelected={(option, value) =>
                            option.title === value.title
                          }
                          getOptionLabel={(option) => option.title}
                          onChange={(e, newValue) => {
                            onDataChanged("ethnicity", newValue.id);
                            setSelectedEthnicity(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        />
                      )}
                      defaultValue={ethnicity[0]}
                      name="ethnicity"
                      control={control}
                    />

                    <ErrorMessage
                      className="invalid-feedback"
                      name="ethnicity"
                      as="div"
                      errors={errors}
                    />
                    {errors.ethnicity && "Select Ethnicity"}
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Is this the first COVID test?
                      <span className="is-required">*</span>
                    </label>
                    <Controller
                      render={() => (
                        <Autocomplete
                          disableClearable
                          value={selectedIsFirstTest}
                          size="small"
                          id="isFirstTest"
                          options={isFirstTest}
                          getOptionSelected={(option, value) =>
                            option.title === value.title
                          }
                          getOptionLabel={(option) => option.title}
                          onChange={(e, newValue) => {
                            onDataChanged("isFirstTest", newValue.id);
                            setSelectedIsFirstTest(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        />
                      )}
                      defaultValue={isFirstTest[0]}
                      name="isFirstTest"
                      control={control}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Is the patient in a group care facility?
                      <span className="is-required">*</span>
                    </label>
                    <Controller
                      render={() => (
                        <Autocomplete
                          disableClearable
                          value={selectedIsInGroup}
                          size="small"
                          id="isInGroup"
                          options={isInGroup}
                          getOptionSelected={(option, value) =>
                            option.title === value.title
                          }
                          getOptionLabel={(option) => option.title}
                          onChange={(e, newValue) => {
                            onDataChanged("isInGroup", newValue.id);
                            setSelectedIsInGroup(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        />
                      )}
                      defaultValue={isInGroup[0]}
                      name="isInGroup"
                      control={control}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <label>
                      Address Line1: <span className="is-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="addressLine1"
                      value={data.addressLine1}
                      maxLength={constrain.addressLine1}
                      className={`upper-case  form-control ${
                        errors.addressLine1 ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "Adress is required",
                      })}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="addressLine1"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <label>Address Line2:</label>
                    <input
                      type="text"
                      name="addressLine2"
                      value={data.addressLine2}
                      maxLength={constrain.addressLine2}
                      className={`upper-case  form-control ${
                        errors.addressLine2 ? "is-invalid" : ""
                      }`}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      City: <span className="is-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="city"
                      value={data.city}
                      maxLength={constrain.city}
                      className={`upper-case  form-control ${
                        errors.city ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "City is required",
                      })}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="city"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      State: <span className="is-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="state"
                      value={data.state}
                      maxLength={constrain.state}
                      className={`upper-case  form-control ${
                        errors.state ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "State is required",
                      })}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="state"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Zip: <span className="is-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="zip"
                      value={data.zip}
                      maxLength={constrain.zip}
                      className={`upper-case  form-control ${
                        errors.zip ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "Zip is required",
                      })}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="zip"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Phone: <span className="is-required">*</span>
                    </label>
                    <InputMask
                      mask="(999) 999-9999"
                      value={data.phone}
                      name="phone"
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                      onChange={(e) => {
                        onDataChanged(e.target.name, e.target.value);
                      }}
                      onBlur={(e) => {
                        checkPhoneValidity(e, "phone");
                      }}
                    />

                    <ErrorMessage
                      className="invalid-feedback"
                      name="phone"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <label>
                      Email: (Note: If you provide your email and verify it,
                      your results will be emailed directly to you when ready. ){" "}
                    </label>
                    <input
                      type="text"
                      name="email"
                      value={data.email}
                      maxLength={constrain.email}
                      className={`form-control ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      onChange={(e) =>
                        onDataChanged(e.target.name, e.target.value)
                      }
                      onBlur={(e) => {
                        checkEmailValidity(e, "email");
                      }}
                    />
                    <ErrorMessage
                      className="invalid-feedback"
                      name="email"
                      as="div"
                      errors={errors}
                    />
                  </div>
                  <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                    <label>
                      Billing: <span className="is-required">*</span>
                    </label>
                    <Controller
                      render={() => (
                        <Autocomplete
                          disableClearable
                          value={selectedBilling}
                          size="small"
                          id="billingType"
                          options={billingTypes}
                          getOptionSelected={(option, value) =>
                            option.title === value.title
                          }
                          getOptionLabel={(option) => option.title}
                          onChange={(e, newValue) => {
                            onDataChanged("billingType", newValue.id);
                            setSelectedBilling(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        />
                      )}
                      defaultValue={billingTypes[0]}
                      name="billingType"
                      control={control}
                    />
                  </div>
                  {selectedBilling.id === 2 && (
                    <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                      <label>
                        Client Code: <span className="is-required"></span>
                      </label>
                      <input
                        type="text"
                        name="clientCode"
                        value={data.clientCode}
                        maxLength={constrain.clientCode}
                        className={`form-control ${
                          errors.clientCode ? "is-invalid" : ""
                        }`}
                        onChange={(e) =>
                          onDataChanged(e.target.name, e.target.value)
                        }
                      />
                      <ErrorMessage
                        className="invalid-feedback"
                        name="clientCode"
                        as="div"
                        errors={errors}
                      />
                    </div>
                  )}
                  {selectedBilling.id === 1 && (
                    <div className="form-group d-flex col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <Checkbox
                        inputId="noIns"
                        onChange={(e) => {
                          setNoIns(e.checked);
                          onDataChanged("noInsChecked", e.checked);
                        }}
                        checked={noIns}
                      ></Checkbox>
                      <label htmlFor="noIns" className="ml-2 p-checkbox-label">
                        I, {data.firstName} {data.lastName}, attest and affirm
                        that I do not have any active health care coverage on
                        the date the testing services were provided. I also
                        understand that I am only eligible for such testing
                        coverage if I do not currently have any other health
                        care coverage, and that if I am ineligible for any such
                        special coverages, I might be responsible for payment.
                      </label>
                    </div>
                  )}
                  {selectedBilling.id === 0 && (
                    <>
                      <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                        <label>
                          Insurance Name: <span className="is-required">*</span>
                        </label>
                        <Controller
                          render={() => (
                            <Autocomplete
                              freeSolo
                              size="small"
                              id="insName"
                              options={insNames}
                              getOptionSelected={(option, value) =>
                                option.title === value.title
                              }
                              getOptionLabel={(option) => option.title}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className={` ${
                                    errors.insName ? "is-invalid" : ""
                                  }`}
                                  onBlur={(e) => {
                                    onDataChanged("insName", e.target.value);
                                  }}
                                  variant="outlined"
                                />
                              )}
                            />
                          )}
                          defaultValue={insNames[0]}
                          name="insName"
                          control={control}
                        />
                        <ErrorMessage
                          className="invalid-feedback"
                          name="insName"
                          as="div"
                          errors={errors}
                        />
                        {errors.insName && (
                          <div className="error-message">
                            {errors.insName.message}
                          </div>
                        )}
                      </div>

                      <div className="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        <label>
                          Insurance ID: <span className="is-required">*</span>
                        </label>
                        <input
                          type="text"
                          name="insID"
                          value={data.insID}
                          maxLength={constrain.insID}
                          className={`form-control ${
                            errors.insID ? "is-invalid" : ""
                          }`}
                          ref={register({
                            required: "Insurance ID is required",
                          })}
                          onChange={(e) =>
                            onDataChanged(e.target.name, e.target.value)
                          }
                        />
                        <ErrorMessage
                          className="invalid-feedback"
                          name="insID"
                          as="div"
                          errors={errors}
                        />
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                        <label>Group No.:</label>
                        <input
                          type="text"
                          name="insGroup"
                          value={data.insGroup}
                          maxLength={constrain.insGroup}
                          className={`form-control ${
                            errors.insGroup ? "is-invalid" : ""
                          }`}
                          onChange={(e) =>
                            onDataChanged(e.target.name, e.target.value)
                          }
                        />
                        <ErrorMessage
                          className="invalid-feedback"
                          name="insGroup"
                          as="div"
                          errors={errors}
                        />
                      </div>

                      <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                        <label>
                          Relation: <span className="is-required">*</span>
                        </label>
                        <Controller
                          render={() => (
                            <Autocomplete
                              disableClearable
                              value={selectedRel}
                              size="small"
                              id="insRel"
                              options={insRel}
                              getOptionSelected={(option, value) =>
                                option.title === value.title
                              }
                              getOptionLabel={(option) => option.title}
                              onChange={(e, newValue) => {
                                onDataChanged("insRel", newValue.id);
                                setSelectedRel(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} variant="outlined" />
                              )}
                            />
                          )}
                          defaultValue={insRel[0]}
                          name="insRel"
                          control={control}
                        />
                      </div>
                      <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                        <label>
                          Subscriber Name:
                          <span className="is-required">*</span>
                        </label>
                        <input
                          disabled={data.insRel === 0 ? true : false}
                          type="text"
                          name="insSubName"
                          value={
                            data.insRel === 0
                              ? data.firstName + " " + data.lastName
                              : data.insSubName
                          }
                          maxLength={constrain.insSubName}
                          className={`upper-case  form-control ${
                            errors.insSubName ? "is-invalid" : ""
                          }`}
                          ref={register({
                            required: "Subscriber name is required",
                          })}
                          onChange={(e) =>
                            onDataChanged(e.target.name, e.target.value)
                          }
                        />

                        <ErrorMessage
                          className="invalid-feedback"
                          name="insSubName"
                          as="div"
                          errors={errors}
                        />
                      </div>
                      <div className="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3">
                        <label>
                          Subscriber D.O.B:
                          <span className="is-required">*</span>
                        </label>
                        <div
                          className={`${
                            errors.insSubDOB ? "is-invalid-date" : ""
                          }`}
                        >
                          <DatePicker
                            maxDate={new Date()}
                            disabled={data.insRel === 0 ? true : false}
                            renderCustomHeader={({
                              date,
                              changeYear,
                              changeMonth,
                              decreaseMonth,
                              increaseMonth,
                              prevMonthButtonDisabled,
                              nextMonthButtonDisabled,
                            }) => (
                              <div
                                style={{
                                  margin: 10,
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  onClick={decreaseMonth}
                                  disabled={prevMonthButtonDisabled}
                                >
                                  {"<"}
                                </button>
                                <select
                                  value={getYear(date)}
                                  onChange={({ target: { value } }) =>
                                    changeYear(value)
                                  }
                                >
                                  {years.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <select
                                  value={months[getMonth(date)]}
                                  onChange={({ target: { value } }) =>
                                    changeMonth(months.indexOf(value))
                                  }
                                >
                                  {months.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <button
                                  onClick={increaseMonth}
                                  disabled={nextMonthButtonDisabled}
                                >
                                  {">"}
                                </button>
                              </div>
                            )}
                            name="insSubDOB"
                            selected={
                              data.insRel === 0 ? data.dob : data.insSubDOB
                            }
                            onChange={(e) => onDataChanged("insSubDOB", e)}
                            onBlur={(e) => checkDateValidity(e, "insSubDOB")}
                            className="form-control"
                          />
                        </div>
                        <div className="error-message">
                          {errors.insSubDOB && errors.insSubDOB.message}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default UserData;
